/* esm.sh - @radix-ui/react-arrow@1.1.8 */
export * from "/*@radix-ui/react-arrow@1.1.8/esnext/react-arrow.mjs";
